
import React from 'react';
import { Music } from 'lucide-react';

const EmptyTracksList: React.FC = () => {
  return (
    <div className="text-center py-8 text-muted-foreground">
      <Music size={40} className="mx-auto mb-4 opacity-50" />
      <h3 className="text-lg font-medium mb-1">No featured tracks yet</h3>
      <p>Add some tracks to showcase on the homepage</p>
    </div>
  );
};

export default EmptyTracksList;
